var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action"},[_c('router-link',{attrs:{"to":{name: 'enter-name'}}},[_c('button',{staticClass:"light-candle"},[_vm._v("Click here to Light a Candle")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }